import { TrackingMethod, TrackingProvider } from '../domain/Tracking'

export function formatTrackingProviderName(provider?: TrackingProvider) {
  switch (provider) {
    case TrackingProvider.TT:
      return 'Trucker Tools'
    case TrackingProvider.MACROPOINT:
      return 'Macropoint'
    default:
      return undefined
  }
}

export function formatTrackingMethodName(method?: TrackingMethod) {
  switch (method) {
    case TrackingMethod.ELD:
      return 'ELD'
    case TrackingMethod.API:
      return 'API'
    case TrackingMethod.EDI:
      return 'EDI'
    case TrackingMethod.Mobile:
      return 'Mobile'
    case TrackingMethod.Manual:
      return 'Manual'
    default:
      return undefined
  }
}

export function formatPreferredProviderTagContent(
  method?: TrackingMethod,
  provider?: TrackingProvider
) {
  if (!method) return undefined

  switch (method) {
    case TrackingMethod.ELD:
    case TrackingMethod.Mobile:
    case TrackingMethod.API:
      return formatTrackingProviderName(provider)
    default:
      return 'No provider needed'
  }
}
